import ScrollOut from "scroll-out";

function setScrollOut() {
  //フロントページ用
  if (document.querySelector('.home')) {
    // スクロールイベントをウィンドウに対して設定
    window.addEventListener('scroll', function() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      handleScroll(scrollTop);
    });

    function handleScroll(scrollTop) {
      var targetAreaList = document.querySelectorAll(".main-visual, .works-section, .top-works, .works-section__project");
      var isInTargetArea = {};

      targetAreaList.forEach(function(targetArea) {
        var areaTop = targetArea.getBoundingClientRect().top + window.scrollY;
        var areaBottom = areaTop + targetArea.offsetHeight;

        if (scrollTop >= areaTop && scrollTop < areaBottom) {
          isInTargetArea[targetArea.id] = true;
        } else {
          isInTargetArea[targetArea.id] = false;
        }
      });

      updateBodyClass(isInTargetArea);
    }

    function updateBodyClass(isInTargetArea) {
      var body = document.body;

      for (var areaId in isInTargetArea) {
        if (isInTargetArea[areaId]) {
          body.classList.add("is-in-" + areaId);
        } else {
          body.classList.remove("is-in-" + areaId);
        }
      }
    }

    // 初期状態の設定
    handleScroll(window.scrollY || document.documentElement.scrollTop);
  }

  // お知らせページ用
  if (document.querySelector('.year-content')) {
    ScrollOut({
      targets: '.year-content',
      once: false, // 一度だけ反応しないように設定
      threshold: 0.6
    });
  }

  // 事例シングルページ用
  if (document.querySelector('.single-works')) {
    var body = document.body;
    ScrollOut({
      targets: '.gallery-item',
      once: true, // 一度だけ反応
      threshold: 0.6
    });
    ScrollOut({
      targets: '.works-cat-archive',
      once: false, // 一度だけ反応しないように設定
      threshold: 0,
      onShown: function(el) {
        body.classList.add("is-cat-archive");
      },
      onHidden: function(el) {
        body.classList.remove("is-cat-archive");
      }
    });
  }
  // LP用
  if (document.getElementById('space')) {
    ScrollOut({
      targets: '#space .wp-block-columns',
      once: true,
      threshold: 0.6 //1で全て入ったら反応
    });
  }
  if (document.getElementById('example')) { //事例
    ScrollOut({
      targets: '#example .wp-block-group',
      once: true
    });
  }
  if (document.getElementById('cando')) { //できること
    ScrollOut({
      targets: '#cando .wp-block-columns>div:last-of-type .wp-block-group>.wp-block-columns>div:first-of-type h3, #cando .wp-block-columns>div:last-of-type .wp-block-group p',
      once: true,
      threshold: 0.9 //1で全て入ったら反応
    });
  }
  if (document.getElementById('workflow')) { //ご相談からお引渡しまで
    ScrollOut({
      targets: '#workflow .lp-toggle > .wp-block-group',
      once: true
    });
  }
  if (document.getElementById('FAQ')) { //よくある質問
    ScrollOut({
      targets: '#FAQ .lp-toggle > .wp-block-group',
      once: true
    });
  }
  
  var body = document.body;

  ScrollOut({
    targets: '.site-footer',
    threshold: 0,
    onShown: function(el) {
      body.classList.add("is-footer");
    },
    onHidden: function(el) {
      body.classList.remove("is-footer");
    }
  });
}

setScrollOut();
